import React from "react";
import { Card, CardContent } from "components/ui/card";
import { Skeleton } from "components/ui/skeleton";

/**
 * Skeleton placeholder for the dashboard stats card.
 * Matches the layout: gradient bar, label, value, icon box, and footer line.
 */
const StatsCardSkeleton = () => {
  return (
    <Card className="stats-card relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-s360-violet to-s360-violet-300" />
      <CardContent className="px-0">
        <div className="flex items-center justify-between">
          <div className="flex-1 space-y-2">
            <Skeleton className="h-4 w-28 bg-gray-200" />
            <Skeleton className="h-9 w-16 bg-gray-200" />
          </div>
          <Skeleton className="h-12 w-12 rounded-lg bg-gray-200 shrink-0" />
        </div>
        <div className="mt-4 flex items-center gap-2">
          <Skeleton className="h-4 w-4 rounded bg-gray-200" />
          <Skeleton className="h-4 w-8 bg-gray-200" />
          <Skeleton className="h-4 w-24 bg-gray-200" />
        </div>
      </CardContent>
    </Card>
  );
};

export default StatsCardSkeleton;
